import React from "react";
import { Helmet } from "react-helmet";
import { colors, serif } from "../../theme/brand";

const services = [
  {
    n: "01",
    title: "AI- & LLM-platformen",
    body: "Van idee tot productie: AI-pipelines die gesprekken, documenten en tekst op schaal analyseren. We bouwen LLM-workflows voor classificatie, samenvatting en kwaliteitsbeoordeling, en zoek- en aanbevelingssystemen op basis van embeddings. Evaluatie en observability zitten er vanaf dag één in, zodat de kwaliteit van de output meetbaar is en blijft verbeteren.",
    stack: ["Python", "FastAPI", "LangChain", "LangGraph", "LangSmith", "Hugging Face", "Prompt engineering"],
  },
  {
    n: "02",
    title: "Interim CTO & tech lead",
    body: "Technisch leiderschap op het moment dat het telt. We nemen de technische strategie, de architectuur en de roadmap op ons en schuiven aan bij directie, product, sales en klanten. Daar vertalen we businessvragen naar haalbare oplossingen, doen we technische discovery bij (enterprise)prospects en houden we scope, planning en kwaliteit strak in de hand.",
    stack: ["Solution architecture", "Technische discovery", "Roadmap", "Delivery"],
  },
  {
    n: "03",
    title: "Platform engineering & cloud",
    body: "Cloudinfrastructuur vanaf nul, volledig als code. We bouwen single-tenant omgevingen, Kubernetes-clusters, CI/CD en monitoring op GCP, Azure of AWS: reproduceerbaar, veilig en klaar om op te schalen. We hebben dit meerdere keren van een leeg account tot productie gebracht.",
    stack: ["GCP", "Azure", "AWS", "Terraform", "Kubernetes", "Helm", "ArgoCD", "GitHub Actions", "GitLab CI"],
  },
  {
    n: "04",
    title: "Backend, API's & integraties",
    body: "Bedrijfskritische backends die gewoon blijven werken. We bouwen microservices en event-driven architecturen, GraphQL- en REST-API's en koppelingen met betaalproviders, fulfilmentsystemen en externe partners. Een voorbeeld: een wereldwijde betaalarchitectuur met 4 betaalproviders en meer dan 30 betaalmethoden.",
    stack: ["TypeScript", "Node.js", "NestJS", "Python", "GraphQL (Apollo Federation)", "RabbitMQ", "Azure Service Bus", "Redis"],
  },
  {
    n: "05",
    title: "Data-platformen & analytics",
    body: "Van ruwe data naar inzicht. We bouwen datapijplijnen en datamodellen voor rapportage op schaal, topic modelling en het vinden van terugkerende patronen, bijvoorbeeld in duizenden klantgesprekken per dag.",
    stack: ["BigQuery", "PostgreSQL", "Firestore", "DynamoDB", "Apache Airflow", "Topic modelling"],
  },
  {
    n: "06",
    title: "Modernisering & teams opbouwen",
    body: "We brengen legacy-monolieten stap voor stap naar een moderne, cloud-native architectuur, zonder big bang. We leggen de fundering (patronen, standaarden, CI/CD) en stellen waar nodig via een vertrouwd netwerk het juiste team samen. Daarna coachen we ontwikkelaars tot ze het platform zelf kunnen dragen.",
    stack: ["Legacy-migratie", "Microservices", "Engineering-standaarden", "Mentoring", "Kennisoverdracht"],
  },
];

export default function AppDiensten() {
  return (
    <div style={{ animation: "fadeUp .5s ease both" }}>
      <Helmet>
        <title>Diensten — Datails</title>
        <meta
          name="description"
          content="AI- en LLM-platformen, interim CTO, platform engineering op GCP, Azure en AWS, backend en integraties, data-platformen en modernisering. Datails schaalt mee met wat je project vraagt."
        />
      </Helmet>

      <section style={{ maxWidth: 1120, margin: "0 auto", padding: "88px 32px 40px" }}>
        <p style={{ fontSize: 14, fontWeight: 600, letterSpacing: "0.06em", textTransform: "uppercase", color: colors.teal, marginBottom: 16 }}>
          Diensten
        </p>
        <h1 style={{ fontFamily: serif, fontWeight: 400, fontSize: "clamp(40px,5.5vw,68px)", lineHeight: 1.04, letterSpacing: "-0.015em", maxWidth: 820, textWrap: "balance" }}>
          Kies één partner. Krijg het hele traject.
        </h1>
        <p style={{ fontSize: 19, lineHeight: 1.55, color: colors.text, marginTop: 26, maxWidth: 640 }}>
          Van strategisch advies en architectuur tot een draaiend AI-, data- of commerceplatform met het juiste team
          eromheen. We schalen mee met wat je project vraagt, en we bouwen zelf mee.
        </p>
      </section>

      <section
        style={{
          maxWidth: 1120,
          margin: "0 auto",
          padding: "24px 32px 96px",
          display: "flex",
          flexDirection: "column",
          gap: 1,
          background: colors.border,
          borderRadius: 18,
          overflow: "hidden",
          border: `1px solid ${colors.border}`,
        }}
      >
        {services.map((s) => (
          <div key={s.n} style={{ background: colors.cream, padding: "44px 40px", display: "grid", gridTemplateColumns: "80px 1fr", gap: 24 }}>
            <div style={{ fontFamily: serif, fontSize: 40, color: colors.teal }}>{s.n}</div>
            <div style={{ maxWidth: 700 }}>
              <h3 style={{ fontSize: 26, fontWeight: 600, marginBottom: 12 }}>{s.title}</h3>
              <p style={{ fontSize: 17, lineHeight: 1.6, color: colors.textMuted }}>{s.body}</p>
              <div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginTop: 20 }}>
                {s.stack.map((t) => (
                  <span key={t} style={{ padding: "6px 12px", border: `1px solid ${colors.border}`, background: colors.panel, borderRadius: 999, fontSize: 13.5, fontWeight: 600, color: colors.ink }}>
                    {t}
                  </span>
                ))}
              </div>
            </div>
          </div>
        ))}
      </section>

      <section style={{ background: colors.panel, borderTop: `1px solid ${colors.border}` }}>
        <div style={{ maxWidth: 1120, margin: "0 auto", padding: "80px 32px", textAlign: "center" }}>
          <h2 style={{ fontFamily: serif, fontWeight: 400, fontSize: "clamp(30px,4vw,46px)", lineHeight: 1.08, maxWidth: 640, margin: "0 auto" }}>
            Niet zeker welke vorm past? Dat zoeken we samen uit.
          </h2>
          <a
            href="mailto:info@datails.nl"
            style={{ display: "inline-flex", alignItems: "center", gap: 9, background: colors.ink, color: colors.cream, padding: "15px 28px", borderRadius: 999, fontSize: 16, fontWeight: 600, marginTop: 28 }}
          >
            Mail ons →
          </a>
        </div>
      </section>
    </div>
  );
}
